import { gsap } from "gsap";

export default class PageTransition {
    constructor(element) {
        this.overlay1 = element;
        this.overlay2 = document.getElementById("pt-2");
        this.init();
    }

    init() {
        gsap.set([this.overlay1, this.overlay2], { yPercent: 0 });

        const tl = gsap.timeline();

        tl.to(this.overlay1, {
            yPercent: -100,
            duration: 0.7,
            ease: "power3.inOut",
        })
        .to(this.overlay2, {
            yPercent: -100,
            duration: 0.9,
            ease: "expo.inOut",
        }, "-=0.4");

        const playIntro = () => {
            gsap.killTweensOf([this.overlay1, this.overlay2]);
            gsap.set([this.overlay1, this.overlay2], { yPercent: 0 });
            gsap.timeline()
                .to(this.overlay1, {
                    yPercent: -100,
                    duration: 0.7,
                    ease: "power3.inOut",
                })
                .to(this.overlay2, {
                    yPercent: -100,
                    duration: 0.9,
                    ease: "expo.inOut",
                }, "-=0.4");
        };

        window.addEventListener("pageshow", (e) => {
            if (e.persisted) playIntro();
        });

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
                const transform = window.getComputedStyle(this.overlay1).transform;
                const matrix = new DOMMatrix(transform);
                const isCovering = matrix.m42 >= 0;
                if (isCovering) playIntro();
            }
        });

        document.querySelectorAll("a").forEach((link) => {
            const href = link.getAttribute("href");
            if (!href || href.startsWith("#") || href.startsWith("mailto") || link.target === "_blank") return;

            link.addEventListener("click", (e) => {
                e.preventDefault();

                gsap.set([this.overlay1, this.overlay2], { yPercent: 100 });

                const tl = gsap.timeline({
                    onComplete: () => window.location.href = href,
                });

                tl.to(this.overlay2, {
                    yPercent: 0,
                    duration: 0.9,
                    ease: "expo.inOut",
                })
                .to(this.overlay1, {
                    yPercent: 0,
                    duration: 0.7,
                    ease: "power3.inOut",
                }, "-=0.4");
            });
        });
    }
}